export default {
  pageName: 'URL Analysis List',
  pageId: '25083',
  pagePath: '/opinion/AIAnalysisHub/URLAnalysis?tab=savedAnalysisList',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    PreviewAnalysis: {
      buttonId: '2508301',
    },
    SearchAnalysis: {
      buttonId: '2508302',
    },
    DownloadReport: {
      buttonId: '2508303',
    },
    DeleteAnalysis: {
      buttonId: '2508304',
    },
  },
};
